import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { COUNTRIES } from '../../common/constants/countries';
import { TIMEZONE_LIST } from '../../common/constants/timezones';
import { Language } from '../../common/constants/language';
import { APP_LANGUAGES } from '../../services';
import { UnitSystem } from '../../common';

@Component({
  selector: 'container-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() set organizationCountry(country: string) {
    this.form.get('country').setValue(country);
  }
  @Output() emailBlur = new EventEmitter<boolean>();

  languageList: Language[] = APP_LANGUAGES;
  countries = COUNTRIES;
  timezoneList = TIMEZONE_LIST;
  unitSystemValues: UnitSystem[] = Object.values(UnitSystem);

  onEmailBlurEvent(): void {
    this.emailBlur.emit(true);
  }
}
